import * as Yup from "yup";

export const dotInspectionValidationSchema = Yup.object().shape({
  inspectionDate: Yup.string().required("Inspection date is required"),
  vehicleId: Yup.number()
    .nullable()
    .required("Truck is required")
    .min(1, "Truck is required"),
  points: Yup.number()
    .nullable()
    .integer("Points must be a whole number")
    .min(0, "Points must be a non-negative whole number")
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? null : value
    ),
  amount: Yup.number()
    .nullable()
    .min(0, "Amount must be a positive amount")
    .transform((value, originalValue) =>
      originalValue === "" || originalValue === null ? null : value
    ),
  description: Yup.string()
    .nullable()
    .max(4000, "Description cannot exceed 4000 characters"),
});

export interface DotInspectionFormValues {
  inspectionDate: string;
  claimCompanyId: number | null;
  claimCompanyName: string | null;
  driverEmployeeId: number | null;
  vehicleId: number | null;
  trailerId: number | null;
  points: number | string;
  description: string;
  amount: number | string;
  driverCharged: number | null;
}

export const parseOptionalNumber = (
  value: number | string | null | undefined
): number | null => {
  if (value === "" || value === null || value === undefined) return null;
  const n = Number(value);
  return Number.isFinite(n) ? n : null;
};

export const getInitialDotInspectionFormValues = (): DotInspectionFormValues => ({
  inspectionDate: new Date().toISOString().split("T")[0],
  claimCompanyId: null,
  claimCompanyName: null,
  driverEmployeeId: null,
  vehicleId: null,
  trailerId: null,
  points: "",
  description: "",
  amount: "",
  driverCharged: null,
});
